const EDGE_ZONE = 96;
const REACH_OUTSIDE = 160;
export const MAX_EDGE_SPEED = 10;

interface Box {
	left: number;
	right: number;
	top: number;
	bottom: number;
}

const depthInto = (distance: number) => Math.min(Math.max((EDGE_ZONE - distance) / EDGE_ZONE, 0), 1);

export const getEdgeSpeed = ({ left, right }: Pick<Box, "left" | "right">, x: number) =>
	MAX_EDGE_SPEED * (depthInto(right - x) ** 2 - depthInto(x - left) ** 2);

export const isWithinReach = ({ left, right, top, bottom }: Box, x: number, y: number) =>
	y >= top && y <= bottom && x >= left - REACH_OUTSIDE && x <= right + REACH_OUTSIDE;

const findCarouselInReach = (root: HTMLElement, x: number, y: number) => {
	const carousels = root.querySelectorAll<HTMLElement>('[data-gallery-view="carousel"] [data-gallery-items]');
	for (const items of carousels) {
		const box = items.getBoundingClientRect();
		if (isWithinReach(box, x, y)) return { items, box };
	}
	return null;
};

export class CarouselEdgeScroller {
	private _items: HTMLElement | null = null;
	private _speed = 0;
	private _frame = 0;

	constructor(
		private readonly _root: HTMLElement,
		private readonly _onScroll: () => void,
	) {}

	track = (event: DragEvent) => {
		const found = findCarouselInReach(this._root, event.clientX, event.clientY);
		this._items = found?.items ?? null;
		this._speed = found ? getEdgeSpeed(found.box, event.clientX) : 0;
		if (this._speed && !this._frame) this._frame = requestAnimationFrame(this._tick);
	};

	stop() {
		cancelAnimationFrame(this._frame);
		this._frame = 0;
		this._speed = 0;
		this._items = null;
	}

	private _tick = () => {
		this._frame = 0;
		if (!this._items || !this._speed) return;
		this._items.scrollLeft += this._speed;
		this._onScroll();
		this._frame = requestAnimationFrame(this._tick);
	};
}
